import {Component, Input} from '@angular/core';

@Component({
  selector: 'ba-card',
  templateUrl: 'baCard.html'
})
export class BaCard {
  @Input() cardTitle:String;
  @Input() newActionUrl:String;
  @Input() newActionText:String;
  @Input() newActionUrl2:String;
  @Input() newActionText2:String;
  @Input() copyUrl:String;
  @Input() copyText:String;
  @Input() baCardClass:String;
  @Input() cardType:String;
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baCard/baCard.component.ts